
// fetch(`/recommendations/products.json?product_id=7413034647621&limit=4`)
//   .then(response => response.json())
//   .then(data => {
//     console.log(data.products); // Aqui você obtém os produtos recomendados
//     // Adicione a lógica para renderizar os produtos recomendados na página
//   });

var $ = jQuery = $;

var cc = {
  sections: []
};


const productRecommendationsSection = document.querySelector(".product-recommendations");
if (productRecommendationsSection) {

  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET",productRecommendationsSection.dataset.url, true);
  request.onload = function () {

    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".product-recommendations").innerHTML;
      if (document.body.classList.contains('cc-animate-enabled') && window.innerWidth >= 768) {
        var animationTimeout = typeof document.body.dataset.ccAnimateTimeout !== "undefined" ? document.body.dataset.ccAnimateTimeout : 200;

        if ('IntersectionObserver' in window) {
          var intersectionObserver = new IntersectionObserver((entries, observer) => {
            entries.forEach((entry) => {
              // In view and hasn't been animated yet
              if (entry.isIntersecting && !entry.target.classList.contains("cc-animate-complete")) {
                setTimeout(() => {
                  entry.target.classList.add("-in", "cc-animate-complete");
                }, animationTimeout);

                setTimeout(() => {
                  //Once the animation is complete (assume 5 seconds), remove the animate attribute to remove all css
                  entry.target.classList.remove("data-cc-animate");
                  entry.target.style.transitionDuration = null;
                  entry.target.style.transitionDelay = null;
                }, 5000);

                // Remove observer after animation
                observer.unobserve(entry.target);
              }
            });
          });

          document.querySelectorAll('[data-cc-animate]:not(.cc-animate-init)').forEach((elem) => {
            //Set the animation delay
            if (elem.dataset.ccAnimateDelay) {
              elem.style.transitionDelay = elem.dataset.ccAnimateDelay;
            }

            ///Set the animation duration
            if (elem.dataset.ccAnimateDuration) {
              elem.style.transitionDuration = elem.dataset.ccAnimateDuration;
            }

            //Init the animation
            if (elem.dataset.ccAnimate) {
              elem.classList.add(elem.dataset.ccAnimate);
            }

            elem.classList.add("cc-animate-init");

            //Watch for elem
            intersectionObserver.observe(elem);
          });
        } else {
          //Fallback, load all the animations now
          var elems = document.querySelectorAll('[data-cc-animate]:not(.cc-animate-init)');
          for (var _i = 0; _i < elems.length; _i++) {
            elems[_i].classList.add("-in", "cc-animate-complete");
          }
        }
      }


      // var $swiperCont = $('.section-product-recommendations .swiper-container');

      // if ($swiperCont.length === 1) {
      //   theme.initProductSlider($swiperCont);
      //   setTimeout(() => {
      //     theme.inlineVideos.init(productRecommendationsSection.parentElement);
      //     new ProductBlock();
      //   }, 500);
      // } else {
      //   console.warn('Unable to find .section-product-recommendations');
      // }
    }
  };
  request.send();
}



